import { Component } from '@angular/core';

/*
 * Страница, что удачно Восстановили пароль
 */
@Component({
  selector: 'app-change-password-complete',
  templateUrl: './change-password-complete.component.html',
  styleUrls: ['./change-password-complete.component.scss'],
})
export class ChangePasswordCompleteComponent {}
